// price digit seperator
export function priceDigitSeperator(price) {
  if (price && parseFloat(price) > 0) {
    return Math.ceil(price)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return "";
}

export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function cardNumberSeparator(value) {
  let v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
  let matches = v.match(/\d{4,16}/g);
  let match = (matches && matches[0]) || "";
  let parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(" ");
  } else {
    return value;
  }
}

export function IBANSpaces(str, after) {
  if (!str) {
    return str;
  }
  if (str.length <= 2) {
    return str;
  }
  let v = str.replace(/[^\dA-Z]/g, ""),
    reg = new RegExp(".{" + after + "}", "g");
  return v.replace(reg, function (a) {
    return a + " ";
  });
}

export function removeStringSpaces(iban) {
  if (iban && typeof iban === "string") {
    return iban.replace(/\s/g, "");
  } else if (iban) {
    return iban.toString();
  }
  return iban;
}

export function IBANLength(iban) {
  if (iban !== null) {
    return removeStringSpaces(iban).length;
  }
  return 0;
}

export const addCommas = (num) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

export const removeCommas = (num) => {
  return num.split(",").join("");
};
